var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import Popper from 'vue-popperjs';
import UiSecondaryButton from 'ui/v1/controls/UiSecondaryButton.vue';
import { Component, Prop } from 'vue-property-decorator';
import UiPickerItem from 'ui/v1/controls/picker/UiPickerItem.vue';
import Icon from 'common/UIToolKit/Icon.vue';
var UiRichPicker = /** @class */ (function (_super) {
    __extends(UiRichPicker, _super);
    function UiRichPicker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.classes = ['rounded-sm', 'shadow', 'p-xxs', 'bg-white', 'z-1000'];
        _this.arrowDirection = 'down';
        _this.containerElement = null;
        return _this;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    UiRichPicker.prototype.selectOption = function (option) {
        this.$emit('input', option);
        this.close();
    };
    UiRichPicker.prototype.close = function () {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.$refs.popper.doClose();
    };
    UiRichPicker.prototype.mounted = function () {
        this.containerElement = Array.from(this.$el.childNodes)[0];
    };
    UiRichPicker.prototype.updated = function () {
        var _this = this;
        this.$nextTick(function () {
            var element = Array.from(_this.containerElement.childNodes)[0];
            element.style['margin-left'] = -element.offsetWidth + "px";
        });
    };
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], UiRichPicker.prototype, "value", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Array)
    ], UiRichPicker.prototype, "options", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], UiRichPicker.prototype, "placeholder", void 0);
    UiRichPicker = __decorate([
        Component({
            components: {
                Icon: Icon, UiPickerItem: UiPickerItem, UiSecondaryButton: UiSecondaryButton, Popper: Popper,
            },
        })
    ], UiRichPicker);
    return UiRichPicker;
}(Vue));
export default UiRichPicker;
